export default (currentButton) => {
  const { innerText, href, dataset, ariaLabel } = currentButton
  const { id, name } = dataset

  window.analytics.track(
    'Button Clicked',
    {
      button_text: innerText || ariaLabel,
      destination_url: href,
      button_id: id,
      button_name: name
    },
    () => {
      console.log('[ Segment ] - Button click')
    }
  )
}
